import { useState } from "react";
import Swal from "sweetalert2";

import { REACT_APP_API_ENDPOINT_GET_GENERAL_INFO, REACT_APP_API_ENDPOINT_UPDATE_PERSONAL_INFO, REACT_APP_API_ENDPOINT_UPDATE_PASSWORD } from "../../../Domain/Settings/SettingsVariables";
import { DtoReqUpdateInfo } from "../../Dto/DtosHome/DtosHomeRequest/DtoRequestUpdateInfo";
import { DtoReqUpdatePassword } from "../../Dto/DtosHome/DtosHomeRequest/DtoRequestUpdatePassword";
import { DtoDataResDataInfo } from "../../Dto/DtosHome/DtosHomeResponse/DtoHomeResponseGeneralInfo";
import { DtoResUpdateInfo } from "../../Dto/DtosHome/DtosHomeResponse/DtoResponseUpdateInfo";
import { DtoResUpdatePassword } from "../../Dto/DtosHome/DtosHomeResponse/DtoResponseUpdatePassword";
import { Get } from "../../HTTP/Get";
import { Post } from "../../HTTP/Post";
import { closeSession } from "../FeatureGlobal";

export const FeatureHomein = () => {
  const { AxiosGet } = Get();
  const { AxiosPost } = Post();

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingPasswordUpdate, setLoadingPasswordUpdate] = useState(false);
  const [GeneralInf, setGeneralInf] = useState(DtoDataResDataInfo);

  const [updateRequestPersonalInfo, setRequestUpdatePersonalInfo] = useState(DtoReqUpdateInfo);
  const [updateResponsePersonalInfo, setUpdateResponsePersonalInfo] = useState(DtoResUpdateInfo);

  const [updatePasswordRequest, setUpdatePasswordRequest] = useState(DtoReqUpdatePassword);
  const [updatePasswordResponse, setUpdatePasswordResponse] = useState(DtoResUpdatePassword);

  const callGeneralInfo = () => {
    AxiosGet(`${REACT_APP_API_ENDPOINT_GET_GENERAL_INFO}`, true).then(suss => {
      setGeneralInf(suss.data)
      setRequestUpdatePersonalInfo(suss.data)
    }).catch(error => {
      //console.log(error);
      closeSession()
    });
  }
  
  const updateGeneralInfo = () => {
    setLoadingUpdate(true);
    AxiosPost(`${REACT_APP_API_ENDPOINT_UPDATE_PERSONAL_INFO}`, updateRequestPersonalInfo, true)
    .then((success) => {
        setUpdateResponsePersonalInfo(success.data);
        setLoadingUpdate(false);
        Swal.fire({
          title: success.mensaje,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'button_confirm'
          }
        });
      })
      .catch((error) => {
        //console.log(error);
        setLoadingUpdate(false)
      })
  }

  const updatePassword = async () => {
    setLoadingPasswordUpdate(true);

    const response = await AxiosPost(REACT_APP_API_ENDPOINT_UPDATE_PASSWORD, updatePasswordRequest, true);
    switch (response?.codigo) {
      case 0:
        setUpdatePasswordResponse(response);
        Swal.fire({
          text: response.mensaje,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: "button_confirm",
            closeButton: "button_close_modal",
          },
        });
        break;
      case 1:
        setUpdatePasswordResponse(response);
        Swal.fire({
          text: response.mensaje,
          icon: 'warning',
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: "button_confirm",
            closeButton: "button_close_modal",
          },
        });
        break;
      default:
        break;
    }
    setLoadingPasswordUpdate(false);
  }

  const handleUpdateInfoDto = (value, field) => {
    setRequestUpdatePersonalInfo({
      ...updateRequestPersonalInfo,
      [field]: value
    });
  };

  const handleUpdatePasswordDto = (value, field) => {
    setUpdatePasswordRequest({
      ...updatePasswordRequest,
      [field]: value
    });
  };

  return {
    GeneralInf,
    loadingUpdate,
    updatePassword,
    updatePasswordResponse,
    callGeneralInfo,
    updateGeneralInfo,
    handleUpdateInfoDto,
    loadingPasswordUpdate,
    updatePasswordRequest,
    handleUpdatePasswordDto,
    updateRequestPersonalInfo,
    updateResponsePersonalInfo,
  }

}